import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';

import imagemFundoEstadioTv from './assets/fundos/fundoTvSite.png';

function TelevisaoListas({ aoSair, setEcraAtivo, setDadosUtilizador }) {
  const [pesquisaCraque, setPesquisaCraque] = useState("");
  const [abaAtual, setAbaAtual] = useState('bancadas'); // 'bancadas' ou 'lives'
  const [salasAtivas, setSalasAtivas] = useState([]);
  const [livesNoAr, setLivesNoAr] = useState([]);
  const [batalhasNoAr, setBatalhasNoAr] = useState([]);
  const [carregando, setCarregando] = useState(true); // Tranca protetora contra o piscar feio

    // SENSOR EM TEMPO REAL: Captura todas as bancadas e ordena pelo movimento ("mais quentes")
  useEffect(() => {
    const salasRef = collection(db, "salas_bancada");
    const q = query(salasRef, where("ativa", "==", true));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const lista = [];
      snapshot.forEach((doc) => {
        lista.push({ id: doc.id, ...doc.data() });
      });

      // ALGORITMO MAIS QUENTES PARA SALAS: Ordena por presentes enviados, total de taps ou participantes
      lista.sort((a, b) => {
        const calorB = b.totalPresentes || b.totalTapTaps || b.quantidadeParticipantes || 0;
        const calorA = a.totalPresentes || a.totalTapTaps || a.quantidadeParticipantes || 0;
        return calorB - calorA;
      });

      setSalasAtivas(lista);
      setCarregando(false); // Desliga a tranca: dados recebidos com sucesso!
    }, (error) => {
      console.error("Erro no sensor de bancadas:", error);
      setCarregando(false); // Desliga também em caso de erro para não travar o ecrã
    });

    return () => unsubscribe();
  }, []);

  // SENSOR EM TEMPO REAL QUE ATUALIZA A LISTA DA TV COM AS LIVES NO AR (BLOCO 11 DO TOSHIBA)
  useEffect(() => {
    const q = query(collection(db, "lives_activas"), orderBy("criadoEm", "desc"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaLives = [];
      snapshot.forEach((doc) => {
        // Não mostra lives encerradas nem a TUA própria live (entravas como dono sem querer)
        if (doc.data()?.status !== "encerrada" && doc.id !== auth.currentUser?.uid) {
          listaLives.push({ id: doc.id, ...doc.data() });
        }
      });

      // ALGORITMO TAP TAP: a live com MAIS tap-taps ou presentes fica sempre no topo do feed.
      listaLives.sort((a, b) => {
        const calorB = (b.totalTapTaps || 0) + (b.totalPresentes || 0);
        const calorA = (a.totalTapTaps || 0) + (a.totalPresentes || 0);
        if (calorB !== calorA) return calorB - calorA;
        return (b.criadoEm?.seconds || 0) - (a.criadoEm?.seconds || 0);
      });

      setLivesNoAr(listaLives);
    });

    return () => unsubscribe();
  }, []);


    // SENSOR EM TEMPO REAL: Captura as batalhas ativas na Arena que não terminaram
  useEffect(() => {
    const q = query(collection(db, "batalhasAtivas"), orderBy("timestampCriacao", "desc"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaBatalhas = [];
      const meuUid = auth.currentUser?.uid;

      snapshot.forEach((doc) => {
        const dados = doc.data();
        if (dados?.fase !== "FIM" && dados?.idA !== meuUid && dados?.idB !== meuUid) {
          listaBatalhas.push({ 
            id: doc.id, 
            isBatalha: true,
            ...dados 
          });
        }
      });
      
      // ALGORITMO MAIS QUENTES (ARENA): Ordena pela soma de pontos dos dois jogadores (maior pontuação no topo)
      listaBatalhas.sort((a, b) => {
        const pontosB = (b.pontosA || 0) + (b.pontosB || 0);
        const pontosA = (a.pontosA || 0) + (a.pontosB || 0);
        return pontosB - pontosA;
      });

      setBatalhasNoAr(listaBatalhas);
    });

    return () => unsubscribe();
  }, []);

  // 🚀 SENSOR EM TEMPO REAL EXTRA: Captura as batalhas ativas exclusivas da LIGA PK para o público assistir
  useEffect(() => {
    const qLiga = query(collection(db, "batalhasAtivas_liga"), orderBy("criadoEmCampeonato", "desc"));
    const meuUid = auth.currentUser?.uid;

    const unsubscribeLiga = onSnapshot(qLiga, (snapshot) => {
      const listaBatalhasLiga = [];

      snapshot.forEach((doc) => {
        const dados = doc.data();
        const faseAtual = String(dados?.fase || "ESPERA").toUpperCase().trim();
        
        if (faseAtual !== "FIM" && dados?.idA !== meuUid && dados?.idB !== meuUid) {
          listaBatalhasLiga.push({
            id: doc.id,
            isBatalha: true,
            isLiga: true, 
            ...dados
          });
        }
      });

      // Une as batalhas da Liga PK com as batalhas normais da Arena no mesmo feed visual!
      setBatalhasNoAr((prevBatalhas) => {
        const filtradasSemLiga = prevBatalhas.filter(b => !b.isLiga);
        const uniao = [...filtradasSemLiga, ...listaBatalhasLiga];
        
        // Reordena o feed unificado colocando as partidas com mais pontuação geral no topo
        return uniao.sort((a, b) => {
          const totalB = (b.pontosA || 0) + (b.pontosB || 0) + (b.totalPresentes || 0);
          const totalA = (a.pontosA || 0) + (a.pontosB || 0) + (a.totalPresentes || 0);
          return totalB - totalA;
        });
      });
    }, (errLiga) => console.log("Aviso no sensor da TV da liga:", errLiga));

    return () => unsubscribeLiga();
  }, []);

    // NOVO SENSOR: Captura as partidas ativas da Champions para aparecerem na TV
  useEffect(() => {
    const q = query(collection(db, "champions_partidas"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaChampions = [];
      const meuUid = auth.currentUser?.uid;

      snapshot.forEach((doc) => {
        const dados = doc.data();
        if (dados?.fase !== "FIM" && dados?.idA !== meuUid && dados?.idB !== meuUid) {
          listaChampions.push({ 
            id: doc.id, 
            isBatalha: true, 
            isChampions: true, 
            ...dados 
          });
        }
      });

      setBatalhasNoAr(prev => {
        const filtradas = prev.filter(b => !b.isChampions);
        const uniao = [...filtradas, ...listaChampions];
        
        return uniao.sort((a, b) => {
          const totalB = (b.pontosA || 0) + (b.pontosB || 0) + (b.totalPresentes || 0);
          const totalA = (a.pontosA || 0) + (a.pontosB || 0) + (a.totalPresentes || 0);
          return totalB - totalA;
        });
      });
      setCarregando(false); // 🟢 Tranca desativada com segurança
    }, (error) => {
      console.error("Erro no sensor da Champions:", error);
      setCarregando(false);
    });

    return () => unsubscribe();
  }, []);

  // 🛡️ PASSO 4: ESCUDO PROTETOR CONTRA O PISCAR (Mete exatamente aqui, na linha 181!)
  if (carregando) {
    return (
      <div style={{ width: '100vw', height: '100vh', backgroundColor: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      </div>
    );
  }

    // ALGORITMO MESTRE: Junta as lives a solo e as batalhas da Arena na mesma lista ordenada por calor total
  const todasAsTransmissoesCraques = [...livesNoAr, ...batalhasNoAr].sort((a, b) => {
    // Normalização fiável: Calcula o calor total somando cliques, presentes e pontos de batalhas
    const pontosB = Number(b.pontosA || 0) + Number(b.pontosB || 0);
    const pontosA = Number(a.pontosA || 0) + Number(a.pontosB || 0);
    
    const calorB = Number(b.totalTapTaps || 0) + Number(b.totalPresentes || 0) + pontosB;
    const calorA = Number(a.totalTapTaps || 0) + Number(a.totalPresentes || 0) + pontosA;
    
    if (calorB !== calorA) return calorB - calorA; // O conteúdo com maior pontuação/presentes/cliques fica no topo!
    
    // Critério de desempate secundário se o número de cliques for igual: a mais recente primeiro
    const tempoB = b.isBatalha ? (b.timestampCriacao?.seconds || 0) : (b.criadoEm?.seconds || 0);
    const tempoA = a.isBatalha ? (a.timestampCriacao?.seconds || 0) : (a.criadoEm?.seconds || 0);
    return tempoB - tempoA;
  });

  const tratarEntradaNaBancada = (sala) => {
    // BLINDAGEM DE VISITANTE: Força os IDs na memória para a Teresa entrar como espectadora nativa
    setDadosUtilizador({
      ...sala,
      uid: sala.id,
      id: sala.id
    });
    setEcraAtivo('bancada');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: '70px', /* deixa a barra de navegação inferior (.bottom-nav) visível */
      backgroundImage: `url(${imagemFundoEstadioTv})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundBlendMode: 'overlay',
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
      zIndex: 999,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 'calc(env(safe-area-inset-top) + 10px)',
      color: '#FFF',
      fontFamily: 'sans-serif'
    }}>

    {/* TOPO: BOTÃO VOLTAR E TÍTULO COM EFEITO PREMIUM */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        padding: '16px', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)'
      }}>
        <button 
          onClick={aoSair}
          style={{ 
            backgroundColor: 'transparent', 
            border: 'none', 
            color: '#39FF14', 
            fontSize: '20px', 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px'
          }}
        >
          {/* Fallback nativo moderno caso o ícone da fonte falhe */}
          <span style={{ fontSize: '22px', fontWeight: 'bold' }}>←</span>
        </button>
        <span style={{ 
          marginLeft: '16px', 
          fontSize: '18px', 
          fontWeight: '900', 
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
          background: 'linear-gradient(90deg, #FFF 0%, #AAA 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
      {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "ESTÁDIO TV 📺" : "STADIUM TV 📺"}
        </span>
      </div>

      {/* 🔍 BARRA DE PESQUISA FUTURISTA COM LUPA */}
      <div style={{ 
        padding: '12px 16px', 
        background: 'rgba(17, 17, 17, 0.4)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.03)'
      }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <span style={{ position: 'absolute', left: '14px', color: '#39FF14', fontSize: '15px', filter: 'drop-shadow(0 0 4px rgba(57, 255, 20, 0.4))' }}>🔍</span>
          <input 
            type="text"
          placeholder={(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "Pesquisar craque ou bancada ao vivo..." : "Search player or live stadium..."}
            value={pesquisaCraque}
            onChange={(e) => setPesquisaCraque(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 12px 12px 42px',
              borderRadius: '12px',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              color: '#FFF',
              fontSize: '14px',
              outline: 'none',
              fontFamily: 'sans-serif',
              transition: 'all 0.3s ease',
              boxShadow: 'inset 0 1px 4px rgba(0,0,0,0.5)'
            }}
          />
          {pesquisaCraque && (
            <button 
              onClick={() => setPesquisaCraque("")}
              style={{ 
                position: 'absolute', 
                right: '14px', 
                background: 'rgba(255, 49, 49, 0.15)', 
                border: 'none', 
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#FF3131', 
                fontWeight: 'bold', 
                cursor: 'pointer', 
                fontSize: '11px' 
              }}
            >
              ✕
            </button>
          )}
        </div>
      </div>

    {/* SELECÇÃO DE ABAS FUTURISTA COM EFEITO NEON GLOW */}
      <div style={{ 
        display: 'flex', 
        width: '100%', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)'
      }}>
        <button
          onClick={() => setAbaAtual('bancadas')}
          style={{
            flex: 1,
            padding: '16px 0',
            backgroundColor: 'transparent',
            border: 'none',
            borderBottom: abaAtual === 'bancadas' ? '3px solid #39FF14' : '3px solid transparent',
            color: abaAtual === 'bancadas' ? '#39FF14' : '#888',
            fontWeight: '900',
            fontSize: '13px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            textShadow: abaAtual === 'bancadas' ? '0 0 8px rgba(57, 255, 20, 0.6)' : 'none',
            filter: abaAtual === 'bancadas' ? 'drop-shadow(0 0 2px #39FF14)' : 'none'
          }}
        >
          <span>🎙️</span> {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "BANCADAS AO VIVO" : "LIVE BENCHES"}

        </button>

        <button
          onClick={() => setAbaAtual('lives')}
          style={{
            flex: 1,
            padding: '16px 0',
            backgroundColor: 'transparent',
            border: 'none',
            borderBottom: abaAtual === 'lives' ? '3px solid #39FF14' : '3px solid transparent',
            color: abaAtual === 'lives' ? '#39FF14' : '#888',
            fontWeight: '900',
            fontSize: '13px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            textShadow: abaAtual === 'lives' ? '0 0 8px rgba(57, 255, 20, 0.6)' : 'none',
            filter: abaAtual === 'lives' ? 'drop-shadow(0 0 2px #39FF14)' : 'none'
          }}
        >
          <span>⚽</span> {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "LIVES DOS CRAQUES" : "CRAQUES LIVES"}
        </button>
      </div>

      {/* MIOLO DOS LISTADOS */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px' }}>
        
        {/* ABA 1: LISTAGEM DE BANCADAS REAL-TIME */}
        {abaAtual === 'bancadas' && (
          <div>
            {salasAtivas.length === 0 ? (
              <div style={{ 
                textAlign: 'center', 
                color: '#888', 
                marginTop: '60px', 
                fontSize: '14px',
                background: 'rgba(255, 255, 255, 0.02)',
                padding: '30px 20px',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)'
              }}>
                Nenhum estádio aberto de momento. Abre a tua bancada! 🏟️
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                {salasAtivas
                  .filter((sala) => {
                    if (!pesquisaCraque) return true;
                    const nomeDono = (sala.donoNome || "").toLowerCase();
                    const termoPesquisa = pesquisaCraque.toLowerCase();
                    return nomeDono.includes(termoPesquisa);
                  })
                  .map((sala) => (
                    <div
                      key={sala.id}
                      onClick={() => tratarEntradaNaBancada(sala)}
                      style={{
                        position: 'relative',
                        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
                        backdropFilter: 'blur(12px)',
                        WebkitBackdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: '16px',
                        padding: '16px 12px 12px 12px',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
                        transition: 'transform 0.2s ease',
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                      }}
                    >
                      {/* CRACHÁ EM DIRETO / MODO NO CANTO */}
                      <div style={{ 
                        position: 'absolute', 
                        top: '8px', 
                        left: '8px', 
                        background: 'linear-gradient(90deg, #FF0055 0%, #FF0000 100%)',
                        color: '#fff',
                        fontSize: '8px',
                        fontWeight: '900',
                        padding: '2px 6px',
                        borderRadius: '10px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        boxShadow: '0 0 8px rgba(255, 0, 85, 0.5)'
                      }}>
                        AO VIVO
                      </div>

                      {/* ÍCONE NATIVO DE IDENTIFICAÇÃO NO CANTINHO DO CARTÃO */}
                      <div style={{ 
                        position: 'absolute', 
                        top: '6px', 
                        right: '8px', 
                        fontSize: '12px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        width: '22px',
                        height: '22px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {sala.modo === 'video' ? '📹' : '🎙️'}
                      </div>

                      {/* FOTO DO ANFITRIÃO COM ANEL NEON GLOW */}
                      <div style={{ position: 'relative', marginTop: '10px' }}>
                        <img 
                          src={sala.donoFoto || 'https://placeholder.com'} 
                          alt="Avatar"
                          style={{ 
                            width: '64px', 
                            height: '64px', 
                            borderRadius: '50%', 
                            border: '2px solid #39FF14', 
                            objectFit: 'cover',
                            boxShadow: '0 0 10px rgba(57, 255, 20, 0.4)'
                          }}
                        />
                      </div>
                      
                      {/* NOME E AUDIÊNCIA */}
                      <span style={{ 
                        fontSize: '13px', 
                        fontWeight: '800', 
                        marginTop: '10px', 
                        textAlign: 'center', 
                        color: '#FFF',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        letterSpacing: '0.5px'
                      }}>
                        {sala.donoNome || "CRAQUE"}
                      </span>
                      
                      <span style={{ 
                        fontSize: '11px', 
                        color: '#888', 
                        marginTop: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontWeight: '500'
                      }}>
                        <span style={{ color: '#39FF14' }}>●</span> {sala.audiencia || 0} a assistir
                      </span>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}

  {/* ABA 2: LISTAGEM REAL DE LIVES DOS CRAQUES COM DESIGN PREMIUM */}
        {abaAtual === 'lives' && (
          <div>
            {todasAsTransmissoesCraques.length === 0 ? (
              <div style={{ 
                textAlign: 'center', 
                color: '#888', 
                marginTop: '60px', 
                fontSize: '14px',
                background: 'rgba(255, 255, 255, 0.02)',
                padding: '30px 20px',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.05)'
              }}>
                Nenhum craque em direto de momento. Sê o primeiro! 🎥⚽
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                {todasAsTransmissoesCraques.map((live) => {
                  
                  {/* SE FOR UMA BATALHA ATIVA DA ARENA PK (CARD FUTURISTA DE CONFRONTO) */}
                  if (live.isBatalha) {
                    const primeiroNomeA = live.nomeA ? live.nomeA.split(' ')[0] : 'Craque A';
                    const primeiroNomeB = live.nomeB ? live.nomeB.split(' ')[0] : 'Craque B';

                    return (
                      <div
                        key={live.id}
                        onClick={() => {
                          if (live.isChampions) {
                            setDadosUtilizador({ ...live, uid: live.id, id: live.id, batalhaId: live.id, torneioId: live.salaTorneioId });
                            setEcraAtivo('champions_pk');
                          } else if (live.isLiga) {
                            setDadosUtilizador({ ...live, uid: live.id, id: live.id, batalhaId: live.id, isLiga: true, idLiga: live.idLiga, chaveJornada: live.chaveJornada });
                            setEcraAtivo('arena_pk');
                          } else {
                            setDadosUtilizador({ ...live, uid: live.id, id: live.id, batalhaId: live.id });
                            setEcraAtivo('arena_pk');
                          }
                        }}
                        style={{
                          position: 'relative',
                          background: 'linear-gradient(135deg, rgba(255, 0, 127, 0.08) 0%, rgba(0, 0, 0, 0.6) 100%)',
                          backdropFilter: 'blur(12px)',
                          WebkitBackdropFilter: 'blur(12px)',
                          border: '1px solid rgba(255, 0, 127, 0.4)',
                          borderRadius: '16px',
                          padding: '16px 8px 12px 8px',
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          boxShadow: '0 8px 24px rgba(255, 0, 127, 0.15), inset 0 0 10px rgba(255, 0, 127, 0.05)',
                          transition: 'transform 0.2s ease',
                          boxSizing: 'border-box',
                          overflow: 'hidden'
                        }}
                      >
                        {/* TAG DE BATALHA DINÂMICA */}
                        <div style={{ 
                          position: 'absolute', 
                          top: '8px', 
                          left: '8px', 
                          background: 'linear-gradient(90deg, #FF007F 0%, #7B00FF 100%)',
                          color: '#fff',
                          fontSize: '8px',
                          fontWeight: '900',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          boxShadow: '0 0 8px rgba(255, 0, 127, 0.5)'
                        }}>
                          {live.isChampions ? '🏆 CHAMPIONS' : live.isLiga ? '🏟️ LIGA' : '⚔️ ARENA'}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center', width: '100%', marginTop: '12px' }}>
                          <img 
                            src={live.fotoA || '/hero.png'} 
                            alt="Jogador A"
                            style={{ 
                              width: '42px', 
                              height: '42px', 
                              borderRadius: '50%', 
                              border: '2px solid #ff4444', 
                              objectFit: 'cover',
                              boxShadow: '0 0 8px rgba(255, 68, 68, 0.3)'
                            }}
                            onError={(e) => { e.target.src = '/hero.png'; }}
                          />
                          <span style={{ fontSize: '10px', fontWeight: '900', color: '#FF007F', fontStyle: 'italic', textShadow: '0 0 4px rgba(255,0,127,0.5)' }}>VS</span>
                          <img 
                            src={live.fotoB || '/hero.png'} 
                            alt="Jogador B"
                            style={{ 
                              width: '42px', 
                              height: '42px', 
                              borderRadius: '50%', 
                              border: '2px solid #4444ff', 
                              objectFit: 'cover',
                              boxShadow: '0 0 8px rgba(68, 68, 255, 0.3)'
                            }}
                            onError={(e) => { e.target.src = '/hero.png'; }}
                          />
                        </div>
                        
                        <span style={{ 
                          fontSize: '12px', 
                          fontWeight: '800', 
                          marginTop: '10px', 
                          textAlign: 'center', 
                          color: '#FFF', 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap', 
                          width: '100%',
                          letterSpacing: '0.5px'
                        }}>
                          {primeiroNomeA} vs {primeiroNomeB}
                        </span>

                        <span style={{ 
                          fontSize: '11px', 
                          color: '#FF007F', 
                          marginTop: '6px', 
                          fontWeight: '900', 
                          fontFamily: 'monospace',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '3px',
                          background: 'rgba(255, 0, 127, 0.1)',
                          padding: '2px 8px',
                          borderRadius: '12px'
                        }}>
                          🔥 {live.totalTapTaps || 0} TAPS
                        </span>
                      </div>
                    );
                  }

                                    {/* SE FOR UMA LIVE A SOLO ORIGINAL (DESIGN MODERNIZADO COM VÍDEO FUMADO) */}
                  return (
                    <div
                      key={live.id}
                      onClick={() => {
                        setDadosUtilizador({ ...live, uid: live.id, id: live.id, liveId: live.id });
                        setEcraAtivo('live_campo');
                      }}
                      style={{
                        position: 'relative',
                        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
                        backdropFilter: 'blur(12px)',
                        WebkitBackdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: '16px',
                        padding: '16px 12px 12px 12px',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
                        transition: 'transform 0.2s ease',
                        boxSizing: 'border-box',
                        overflow: 'hidden'
                      }}
                    >
                      {/* EMBLEMA EM DIRETO ESTILO TIKTOK */}
                      <div style={{ 
                        position: 'absolute', 
                        top: '8px', 
                        left: '8px', 
                        background: 'linear-gradient(90deg, #FF0055 0%, #FF0000 100%)',
                        color: '#fff',
                        fontSize: '8px',
                        fontWeight: '900',
                        padding: '2px 6px',
                        borderRadius: '10px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        boxShadow: '0 0 8px rgba(255, 0, 85, 0.5)'
                      }}>
                        LIVE
                      </div>

                      <div style={{ 
                        position: 'absolute', 
                        top: '6px', 
                        right: '8px', 
                        fontSize: '12px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        width: '22px',
                        height: '22px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        🎥
                      </div>

                      <div style={{ position: 'relative', marginTop: '10px' }}>
                        <img 
                          src={live.userFoto || 'https://placeholder.com'} 
                          alt="Avatar Live"
                          style={{ 
                            width: '64px', 
                            height: '64px', 
                            borderRadius: '50%', 
                            border: '2px solid #39FF14', 
                            objectFit: 'cover',
                            boxShadow: '0 0 10px rgba(57, 255, 20, 0.4)'
                          }}
                        />
                      </div>
                      
                      <span style={{ 
                        fontSize: '13px', 
                        fontWeight: '800', 
                        marginTop: '10px', 
                        textAlign: 'center', 
                        color: '#FFF',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        letterSpacing: '0.5px'
                      }}>
                        {live.userName || "CRAQUE"}
                      </span>
                      
                      <span style={{ 
                        fontSize: '11px', 
                        color: '#39FF14', 
                        marginTop: '6px', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        background: 'rgba(57, 255, 20, 0.1)',
                        padding: '2px 8px',
                        borderRadius: '12px'
                      }}>
                        ❤️ {live.totalTapTaps || 0} CURTIDAS
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

export default TelevisaoListas;



